import {
  addSensitiveWordType,
  editSensitiveWordType,
  deleteSensitiveWordType,
  querySensitiveWordTypeList,
} from '../requests';

const initPagination = {
  pageSize: 10,
  currentPage: 1,
  total: 0,
};

const Model = {
  namespace: 'sensitiveWordType',
  state: {
    tabledData: [],
    pagination: initPagination,
    sensitiveType: [],
  },
  effects: {
    *addSensitiveWordType({ payload }, { call }) {
      return yield call(addSensitiveWordType, payload);
    },
    *editSensitiveWordType({ payload }, { call }) {
      return yield call(editSensitiveWordType, payload);
    },
    *deleteSensitiveWordType({ payload }, { call }) {
      return yield call(deleteSensitiveWordType, payload);
    },
    *querySensitiveWordTypeList({ payload }, { call, put }) {
      const res = yield call(querySensitiveWordTypeList, payload);
      if (res && res.code === 0) {
        yield put({ type: 'saveSensitiveWordTypeList', payload: res.data.data });
      }
    },
  },
  reducers: {
    saveSensitiveWordTypeList(state, { payload }) {
      const { pageNum, pageSize, total, dataInfos } = payload;
      const pagination = {
        currentPage: pageNum,
        pageSize,
        total,
      };
      return { ...state, tabledData: dataInfos, pagination };
    },
  },
};
export default Model;
